export var ResourceType;
(function (ResourceType) {
  ResourceType["Article"] = "Article";
  ResourceType["Blog"] = "Blog";
  ResourceType["Book"] = "Book";
  ResourceType["CaseStudy"] = "Case Study";
  ResourceType["CustomerInterview"] = "Customer Interview";
  ResourceType["Course"] = "Course";
  ResourceType["Learning"] = "Learning";
  ResourceType["Doc"] = "Doc";
  ResourceType["Guide"] = "Guide";
  ResourceType["Podcast"] = "Podcast";
  ResourceType["Tutorial"] = "Tutorial";
  ResourceType["Video"] = "Video";
  ResourceType["Whitepaper"] = "Whitepaper";
  ResourceType["Webinar"] = "Webinar";
})(ResourceType || (ResourceType = {}));
export var ResourceSource;
(function (ResourceSource) {
  ResourceSource["Prismic"] = "prismic";
})(ResourceSource || (ResourceSource = {}));
